import React, { useContext } from "react";
import { LayoutContext } from "../../context/LayoutContext";
import { Routes, Route, useLocation } from "react-router-dom";
import routes from "../../routes";
import useAuth from "../../hooks/useAuth";
import PlatformUsersHeader from "./components/PlatformUsersHeader";

const NewUsers = () => {
  const { isBannerVisible } = useContext(LayoutContext);
  const { authRole } = useAuth();
  const location = useLocation();

  const adminProfileReviewRoutes = routes.find((route) => route.path === "/admin/review");

  const childrenRoutes = adminProfileReviewRoutes?.childs || [];
  const visibleRoutes = childrenRoutes.filter(
    (child) => child?.roles?.includes(authRole) && child?.isShow !== false,
  );

  return (
    <div className="bg-light">
      <div
        className={`bg-[#F6F6F6] sm:fixed sticky 2xl:w-[95.2%] xl:w-[93.2%] lg:w-[90.6%] md:w-[87.5%] sm:w-[95%] w-full h-screen transition-all ${
          isBannerVisible ? "top-[106px]" : "top-[56px]"
        }`}
      >
        <PlatformUsersHeader />

        <Routes>
          {visibleRoutes.map((route, idx) => (
            <Route key={idx} path={route.path} element={React.cloneElement(route.component)} />
          ))}

          {visibleRoutes.length > 0 && (
            <Route index element={React.cloneElement(visibleRoutes[0].component)} />
          )}
        </Routes>
      </div>
    </div>
  );
};

export default NewUsers;
